<template lang="html">
	<div class="component colliderproperties">
		<div class="script-name">
			<div style="padding: 4px;display: inline-block;"><i class="icon-now_widgets"></i> <span>Collider</span></div>
			<button type="button" class="btn-icon btn-delete" title="Remove Script" @click="$emit('remove')" style="float: right;font-size: inherit;margin: 0;"><i class="icon-delete"></i></button>
		</div>
		<div class="script-properties">
			<div style="display: flex;flex-wrap: wrap;">
				<div v-for="(label, variable) in {x: 'X', y: 'Y', width: 'W', height: 'H'}" :key="variable" style="width: 50%;padding-right: 8px;padding-top: 8px;">
					<div class="input-group">
						<input type="text" v-model="modelValue[variable]" @change="change()">
						<span class="input-group-append">{{label}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['modelValue'],
	emits: ['update:modelValue', 'remove'],
	methods: {
		change() {
			this.$emit('update:modelValue', this.modelValue);
		}
	}
}
</script>
